var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecapPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.959,
    height: 34.787,
    viewBox: "0 0 25.959 34.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_211",
    "data-name": "Raggruppa 211",
    transform: "translate(-174.825 -441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(165.186 437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Apert-filiale",
    transform: "translate(10.814 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_149",
    "data-name": "Tracciato 149",
    d: "M22.615,5a11.818,11.818,0,0,0-8.093,20.414l8.093,8.064s7.582-7.422,8.3-8.253A11.818,11.818,0,0,0,22.615,5Zm0,17.119a5.393,5.393,0,1,1,4.1-2.015,5.606,5.606,0,0,1-2.929,1.862,4.644,4.644,0,0,1-1.17.131Z",
    transform: "translate(-10.814 -5)",
    fill: "rgba(0,0,0,0)",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_149",
    "data-name": "Linea 149",
    x2: 10.615,
    transform: "translate(6.493 32.787)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_63",
    "data-name": "Ellisse 63",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(181 447)",
    fill: "#ed1c24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecapPinIcon);
export default __webpack_public_path__ + "static/media/recap-pin-icon.7c48a3c777e46ac4d819f79e79ee612e.svg";
export { ForwardRef as ReactComponent };